import InviraRolesCrud from './InviraRolesCrud.vue'
export {InviraRolesCrud}
export default InviraRolesCrud

